module.exports = __webpack_public_path__ + "static/img/7.c4e06cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/7.png
// module id = afkS
// module chunks = 0